module.exports = __webpack_public_path__ + "static/media/javascript.877a81a8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/javascript.svg
// module id = 62
// module chunks = 0